import React, { useEffect, useState } from 'react'
import { RootState } from '../../../global/config/store';
import { useSelector } from 'react-redux';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Autocomplete, Box, Button, FormControl, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { ApiGetAllocationlist, ApiGetPriceChangeLogs, ApiGetAllocationForUpdate, ApiUpdateAllocationPrice,ApiDeleteAllocationPriceChangeLogsById } from '../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';

function UpdatePricing() {
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const [selectedClient, setSelectedClient] = useState<any>(null);
    const [ClientId, setClientId] = useState(null);
    const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
    const reportMonth = selectedDate ? selectedDate.getMonth() + 1 : null;
    const reportYear = selectedDate ? selectedDate.getFullYear() : null;
    const [price, setPrice] = useState<String>();
    const [priceDisplay, setPriceDisplay] = useState<String>();
    const [task, settask] = React.useState<any[]>([]);
    const [priceChangesData, setPriceChangesData] = useState<any>([]);
    const [selectedAllocation, setSelectedAllocation] = useState<any>(null);
    const [allocationData, setAllocationData] = useState<any>([]);


    useEffect(() => {
        if (Clientlist.length > 2) {
            setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        const getallocationlist = async () => {
            const data = `?offset=0&limit=1000&allocationClientGroup=${selectedClient?.clientGroupName}`;
            try {
                const response = await ApiGetAllocationlist(data);
                settask(response.data);
                if (response.data.length > 0) {
                    setSelectedAllocation(response.data[0]);
                } else {
                    setSelectedAllocation(null);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (selectedClient && reportMonth && reportYear) {
            getallocationlist();
        }
    }, [selectedClient]);

    const handlePriceChangeLog = async () => {
        setPriceChangesData([])
        if (selectedClient?.clientGroupName) {
            const data = `?clientGroup=${selectedClient?.clientGroupName}&jobMonth=${reportMonth}&jobYear=${reportYear}`
            try {
                const res = await ApiGetPriceChangeLogs(data);
                setPriceChangesData(res?.data);
            } catch (error) {
                console.log(error)
            }
        }
    }
    useEffect(() => {
        handlePriceChangeLog();
    }, [selectedClient]);

    const ApiForAllocationUpdate = async () => {
        setAllocationData([])
        if (selectedClient?.clientGroupName && selectedAllocation?.allocationId) {
            const data = `?clientGroupName=${selectedClient?.clientGroupName}&allocationId=${selectedAllocation?.allocationId}&jobMonth=${reportMonth}&jobYear=${reportYear}`
            try {
                const res = await ApiGetAllocationForUpdate(data);
                setAllocationData(res?.data)
                setPrice(res?.data?.responseData?.venuePrice)
                setPriceDisplay(res?.data?.responseData?.venuePriceDisplay)
            } catch (error) {
                console.log(error)
            }
        }
    }
    useEffect(() => {
        ApiForAllocationUpdate();
    }, [selectedClient, selectedAllocation, reportMonth, reportYear])

    const handleUpdate = async () => {
        try {
            const data = {
                jobMonth: reportMonth,
                jobYear: reportYear,
                clientGroupName: selectedClient?.clientGroupName,
                allocationId: selectedAllocation?.allocationId,
                venuePrice: String(price),
                venuePriceDisplay: priceDisplay
            }               
            const response = await ApiUpdateAllocationPrice(data);
            toast.success(response.message);
            handlePriceChangeLog();
            ApiForAllocationUpdate();

        } catch (error) {
            console.log(error)
        }
    }
    const handleDelete = async (id) => {
        try {
            const data = `?allocationPriceChangeLogId=${id}`                        
            const response = await ApiDeleteAllocationPriceChangeLogsById(data);       
            toast.success(response.message);
            handlePriceChangeLog();
            ApiForAllocationUpdate();
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Box className="manage-admin-container" padding='20px'>
            <Box className="d-flex align-items-center w-100 py-2 mb-5" sx={{ justifyContent: 'space-between' }}>
                <Box className='d-flex align-items-center col-2' gap={1}>
                    <Stack direction="row" className="ml-0" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedClient(newValue);
                                    settask([])
                                    setSelectedAllocation([])
                                    setClientId(newValue?.clientGroupName || null);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-0" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 200 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={task}
                                getOptionLabel={(option) => option?.venueId?.venueName || ""}
                                isOptionEqualToValue={(option, value) =>
                                    option?.allocationId === value?.allocationId
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedAllocation(newValue);
                                }}
                                value={selectedAllocation}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Allocation" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>
                <Typography fontWeight='bold' variant='h4'>Update Pricing</Typography>
                <Box sx={{ alignItems: 'flex-end', marginRight: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={["month", "year"]}
                            label=""
                            value={selectedDate}
                            onChange={(newDate) => setSelectedDate(newDate)}
                            format="MM/yyyy"
                            sx={{
                                width: "400px",
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 1,
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
            <Box className="d-flex align-items-center w-100 py-2 mb-5 justify-content-center mr-5">
                <Typography fontWeight='20px' variant='h4' marginTop={0}>Allocation For 07/2025</Typography>
            </Box>
            <Table>
                <TableHead>
                    <TableRow className="table-row-background">
                        <TableCell style={{ color: "#fff", }}>Status</TableCell>
                        <TableCell style={{ color: "#fff" }}>Month</TableCell>
                        <TableCell style={{ color: "#fff" }}>Store</TableCell>
                        <TableCell style={{ color: "#fff" }}>Type</TableCell>
                        <TableCell style={{ color: "#fff" }}>Shopper Name</TableCell>
                        <TableCell style={{ color: "#fff" }}>Shopper Date</TableCell>
                        <TableCell style={{ color: "#fff" }}>Shopper Time</TableCell>
                        <TableCell style={{ color: "#fff" }}>Price</TableCell>
                        <TableCell style={{ color: "#fff" }}>Price Display</TableCell>
                        <TableCell style={{ color: "#fff" }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        allocationData?.responseData ? (
                            <TableRow>
                                <TableCell>{allocationData?.responseData?.status}</TableCell>
                                <TableCell>{allocationData?.responseData?.month}/{allocationData?.responseData?.year}</TableCell>
                                <TableCell>{allocationData?.responseData?.store}</TableCell>
                                <TableCell>{allocationData?.responseData?.type}</TableCell>
                                <TableCell>{allocationData?.responseData?.shopperName}</TableCell>
                                <TableCell>{allocationData?.responseData && new Date(allocationData?.responseData?.shopperDate)?.toISOString()?.split("T")[0]}</TableCell>
                                <TableCell>{allocationData?.responseData?.shopperTime}</TableCell>
                                <TableCell>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)}
                                        sx={{ width: '120px' }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={priceDisplay}
                                        onChange={(e) => setPriceDisplay(e.target.value)}
                                        sx={{ width: '300px' }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Button variant="contained" className="table-row-background" onClick={handleUpdate}>
                                        Update
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )
                        : <TableRow><TableCell  className='text-center' colSpan={10}>No Data Found</TableCell></TableRow>
                    }

                </TableBody>
            </Table>

            <Box className="d-flex align-items-center w-100 py-2 mb-5 justify-content-center mr-5">
                <Typography fontWeight='20px' variant='h4' marginTop={10}>Price Change Log</Typography>
            </Box>
            <Table>
                <TableHead>
                    <TableRow className="table-row-background">
                        <TableCell style={{ color: "#fff", }}></TableCell>
                        <TableCell style={{ color: "#fff" }}>Store Name</TableCell>
                        <TableCell style={{ color: "#fff" }}>Group Name</TableCell>
                        <TableCell style={{ color: "#fff" }}>Old Price</TableCell>
                        <TableCell style={{ color: "#fff" }}>Old Price Display</TableCell>
                        <TableCell style={{ color: "#fff" }}>New Price</TableCell>
                        <TableCell style={{ color: "#fff" }}>New Price Display</TableCell>
                        <TableCell style={{ color: "#fff" }}>Changed Date</TableCell>
                        <TableCell style={{ color: "#fff" }}>Change By</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {priceChangesData.length > 0 ? priceChangesData.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Button variant="contained" className="table-row-background" onClick={()=>{handleDelete(item?.allocationPriceChangeLogId)}}>
                                    Delete
                                </Button>
                            </TableCell>
                            <TableCell>{item?.venueName}</TableCell>
                            <TableCell>{item?.clientEntityName}</TableCell>
                            <TableCell>{item?.oldVenuePrice}</TableCell>
                            <TableCell>{item?.oldVenuePriceDisplay}</TableCell>
                            <TableCell>{item?.newVenuePrice}</TableCell>
                            <TableCell>{item?.newVenuePriceDisplay}</TableCell>
                            <TableCell>{new Date(item?.modifiedOn).toLocaleString("en-US", { hour12: true })}</TableCell>
                            <TableCell>{item?.userName}</TableCell>
                        </TableRow>
                    )) : <TableRow><TableCell  className='text-center' colSpan={9}>No Data Found</TableCell></TableRow>}
                </TableBody>
            </Table>
        </Box>
    )
}
export default UpdatePricing;